/**
 * SGKC030A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DiscountextraAmtDto {

    /**
     * 割引割増契約名
     */
    discountextraCtrAname?: string;
    /**
     * 割引割増額
     */
    discountextraAmt?: number;
}

